import React, { useState } from 'react';
import {
  Button,
  Form,
  Modal
} from "react-bootstrap";

import LoadingOverlay from 'src/Components/LoadingOverlay';
import { withdraw } from "src/Services/api";
import Notification, { useNotification } from 'src/Components/Notification';

const OtpModal = props => {
  const [OtpCodes, setOtpCodes] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, onClose, notification } = useNotification();
  const {
    details,
    setShowModal,
    showModal,
    notifySuccess,
    clearForm, } = props;

  const handleClose = () => {
    handleWithdrawal({ status: "cancel" });
    setShowModal(false);
  };

  const handleCodeInput = e => {
    let { name, value } = e.target;
    setOtpCodes(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  const handleWithdrawal = async extra_args => {
    setIsLoading(true);
    const updated_details = { ...details, ...extra_args }
    const withdrawResp = await withdraw(updated_details);

    if (withdrawResp.status === 200 && !withdrawResp.data.reason_for_failure) {
      notifySuccess({ message: "Congratulations! Your payment is on its way." });
      setShowModal(false);
    } else {
      try {
        // Only expect cancel to fall in this category
        notifySuccess({ message: withdrawResp.data.reason_for_failure });
        setShowModal(false);
      }
      catch (err) {
        // expect any 400 errors while inputing codes.
        notifyError({ message : withdrawResp.response.data.reason_for_failure });
      }
    }
    clearForm();
    setOtpCodes({});
    setIsLoading(false);
  };

  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <Notification id="otp-notif" onClose={onClose} {...notification} />
      <Modal.Header closeButton>
        <Modal.Title>Withdraw</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <LoadingOverlay show={isLoading}/>
        <p>
          You are about to send your wallet balance to{" "}
          {details.beneficiary_name}. You will be charged
          &#8358;{details.applicable_fee} and will recieve &#8358;{details.amount_after_charges}
          {" "}for this transaction.
        </p>
        <>
          <Form.Group className="mb-3">
            <Form.Label>Enter Email OTP</Form.Label>
            <Form.Control
              name="email_code"
              type="number"
              value={OtpCodes["email_code"] || ""}
              onChange={handleCodeInput}
            />
            <Form.Text muted>
              Enter the OTP code that was sent to your email
            </Form.Text>
          </Form.Group>
          <Form.Group>
            <Form.Label>Enter Phone OTP</Form.Label>
            <Form.Control
              name="phone_code"
              type="number"
              value={OtpCodes["phone_code"] || ""}
              onChange={handleCodeInput}
            />
            <Form.Text muted>
              Enter the OTP code that was sent to your mobile
              phone
            </Form.Text>
          </Form.Group>
        </>
      </Modal.Body>

      <Modal.Footer>
        <Button
          className="jamlyfOutlineBtn"
          onClick={() => handleWithdrawal(OtpCodes)}
          disabled={isLoading}
        >
          Send
        </Button>
        <Button
          variant="danger"
          onClick={handleClose}
          disabled={isLoading}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default OtpModal;
